<template>
  <div v-if="currentTiers">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-4">
          <div class="card mb-n1">
            <div class="card-body mb-n2">
              <div class="row">
                <div class="col-12">
                  <div
                    class="d-flex flex-column align-items-center justify-content-center text-center"
                  >
                    <img
                      v-if="currentTiers.url_logo"
                      class="rounded-circle"
                      alt="Logo"
                      width="200"
                      height="200"
                      :src="currentTiers.url_logo"
                      data-holder-rendered="true"
                    />
                    <img
                      v-else
                      class="rounded-circle"
                      alt="Logo"
                      width="200"
                      height="200"
                      :src="URL_LOCAL_FILE + '/images/no-image.png'"
                      data-holder-rendered="true"
                    />
                    <div class="mt-3">
                      <p class="text-secondary mb-1">
                        {{ currentTiers.nom }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 col-lg-8">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Nom</span>
                  </td>
                  <td>
                    {{ currentTiers.nom }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Client/Prospect</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.client">Client</span>
                    <span v-else>Prospect</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Code client</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.code_client">{{
                      currentTiers.code_client
                    }}</span>
                    <span v-else>###</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Type Tiers</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.type">{{
                      currentTiers.type.nom
                    }}</span>
                    <span v-else>###</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-envelope text-custom-primary"></i>
                    <span class="font-weight-bold"> Email</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.email">{{
                      currentTiers.email
                    }}</span>
                    <span v-else>###</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-phone text-custom-primary"></i>
                    <span class="font-weight-bold"> Téléphone</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.telephone">{{
                      currentTiers.telephone
                    }}</span>
                    <span v-else>###</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-fax text-custom-primary"></i>
                    <span class="font-weight-bold"> Fax</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.fax">{{ currentTiers.fax }}</span>
                    <span v-else>###</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-globe text-custom-primary"></i>
                    <span class="font-weight-bold"> Site web</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.site_web">{{
                      currentTiers.site_web
                    }}</span>
                    <span v-else>###</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Departement</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.departement">{{
                      currentTiers.departement
                    }}</span>
                    <span v-else>###</span>
                  </td>
                </tr>

                <tr>
                  <td>
                    <i class="fa fa-language text-custom-primary"></i>
                    <span class="font-weight-bold"> Langue</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.langue">{{
                      currentTiers.langue.nom
                    }}</span>
                    <span v-else>###</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Devise principale</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.devise">{{
                      currentTiers.devise.nom
                    }}</span>
                    <span v-else>###</span>
                  </td>
                </tr>

                <tr>
                  <td>
                    <i class="far fa-user text-custom-primary"></i>
                    <span class="font-weight-bold"> Auteur</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.auteur">{{
                      currentTiers.auteur
                    }}</span>
                    <span v-else>###</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Pays</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.pays">{{
                      currentTiers.pays
                    }}</span>
                    <span v-else>###</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Ville</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.ville">{{
                      currentTiers.ville
                    }}</span>
                    <span v-else>###</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-address-card text-custom-primary"></i>
                    <span class="font-weight-bold"> Adresse</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.adresse">{{
                      currentTiers.adresse
                    }}</span>
                    <span v-else>###</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Code postal</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.code_postal">{{
                      currentTiers.code_postal
                    }}</span>
                    <span v-else>###</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-md-12 col-lg-6">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Assujetti à la TVA ? </span>
                  </td>
                  <td>
                    <span v-if="currentTiers.assujetti_tva">Oui</span>
                    <span v-else>Non</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Numero TVA</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.numero_tva">{{
                      currentTiers.numero_tva
                    }}</span>
                    <span v-else>###</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Effectif</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.effectif">{{
                      currentTiers.effectif
                    }}</span>
                    <span v-else>###</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <i class="fa fa-info-circle text-custom-primary"></i>
                    <span class="font-weight-bold"> Capital</span>
                  </td>
                  <td>
                    <span v-if="currentTiers.capital">{{
                      currentTiers.capital
                    }}</span>
                    <span v-else>###</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body mb-n2">
          <div class="row pt-3">
            <div class="col-md-12 col-lg-12 mt-n4 mt-lg-0">
              <div class="form-group">
                <label for="code_client">Affiliations </label>
                <multiselect
                  v-model="affiliations"
                  :options="tiersList"
                  :multiple="true"
                  :hideSelected="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  selectLabel="Tapez Entrez pour selectionner"
                  placeholder="Filtrer par colonne"
                  label="nom"
                  track-by="id"
                  disabled
                >
                  <template slot="option" slot-scope="{ option }">
                    <div class="d-flex flex-column mb-2">
                      <span class="h6 font-weight-bold mb-1">
                        {{ option.nom }}
                      </span>
                      <span class="mb-1">
                        <span class="font-weight-bold mr-2">Type:</span>
                        {{ option.type }}
                      </span>
                      <span v-if="option.email">
                        <i class="fas fa-envelope mr-2"></i>{{ option.email }}
                      </span>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

import config from '@/config';

export default {
  data() {
    return {
      title: 'Gestion tiers - Détails',
      URL_LOCAL_FILE: config.URL_LOCAL_FILE,
      tiersList: [],
      affiliations: [],
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  computed: {
    ...mapGetters('tiers', ['currentTiers']),
  },
  methods: {
    ...mapActions('tiers', ['getTiers']),
    init() {
      this.getTiers(this.$route.params.id).then(() => {
        this.tiersList = this.affiliations = this.currentTiers.affiliations;
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
